import React from "react";

import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import NumberValue from "../../components/NumberValue";



const TabChats: React.FC = () => {
  const stats = useSelector((state: RootState) => state.stats);

  return (
    <Stack direction="column" spacing={4}>
      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Chats</TableCell>
              <TableCell align="right">Count</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">Total</TableCell>
              <TableCell align="right"><NumberValue number={stats.chats?.total}/></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">Active</TableCell>
              <TableCell align="right"><NumberValue number={stats.chats?.active}/></TableCell>
            </TableRow>
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">Deleted</TableCell>
              <TableCell align="right"><NumberValue number={stats.chats?.deleted}/></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Messages</TableCell>
              <TableCell align="right">Count</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">Total</TableCell>
              <TableCell align="right"> <NumberValue number={stats.messages?.total}/> </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">Active</TableCell>
              <TableCell align="right"><NumberValue number={stats.messages?.active}/></TableCell>
            </TableRow>
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">Deleted</TableCell>
              <TableCell align="right"><NumberValue number={stats.messages?.deleted}/></TableCell>
            </TableRow>
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">Text</TableCell>
              <TableCell align="right"><NumberValue number={stats.messages?.text}/></TableCell>
            </TableRow>
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">Photo</TableCell>
              <TableCell align="right"><NumberValue number={stats.messages?.photo}/></TableCell>
            </TableRow>
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">Giphy</TableCell>
              <TableCell align="right"><NumberValue number={stats.messages?.giphy}/></TableCell>
            </TableRow>
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">Sticker</TableCell>
              <TableCell align="right"><NumberValue number={stats.messages?.sticker}/></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};

export default TabChats;